import { DevicesList } from './devices-list.js';
import { PasswordForm, socialLabel } from './password-form.js';
import { useAccountSecurity } from './use-account-security.js';

/**
 * Your password and what is signed in to your account.
 *
 * Deliberately not gated on `readOnly`: that flag is about a household's document, and a
 * viewer still owns their own password. It *is* hidden while impersonating — see the tab
 * list in `index.tsx` — because Better Auth resolves the agent's session here, not the
 * customer's, so every control would act on the wrong person.
 */
export function SecurityTab() {
  const { data, loading, failed, refresh } = useAccountSecurity(true);

  if (failed) {
    return (
      <section className="section-group">
        <h2 className="section-title">Security</h2>
        <p className="hint">
          Your password and signed-in devices are available when you&rsquo;re online.
        </p>
      </section>
    );
  }

  if (loading || data == null) {
    return (
      <section className="section-group">
        <h2 className="section-title">Security</h2>
        <p className="hint">Loading…</p>
      </section>
    );
  }

  return (
    <>
      <section className="section-group">
        <h2 className="section-title">Password</h2>
        {data.hasPassword ? (
          <PasswordForm providers={data.providers} />
        ) : (
          <p className="hint">
            You sign in with {socialLabel(data.providers)}, so there is no password on this
            account to change.
          </p>
        )}
      </section>

      <section className="section-group">
        <h2 className="section-title">Signed-in devices</h2>
        <p className="hint">
          Everything signed in to your account, in every household you belong to.
        </p>
        <DevicesList sessions={data.sessions} onChanged={refresh} />
      </section>
    </>
  );
}
